import { Pipe, PipeTransform } from '@angular/core';
import { DateTime, Duration } from 'luxon';

@Pipe({
    name: 'lxDiff',
    standalone: true
})
export class LuxonDiffPipe implements PipeTransform {

  transform(end: string | DateTime, start: string | DateTime): Duration {
    if (!start || !end) {
      return null;
    }

    if (typeof start === 'string') {
      start = DateTime.fromISO(start);
    }

    if (typeof end === 'string') {
      end = DateTime.fromISO(end);
    }

    if (!start.isValid || !end.isValid) {
      return null;
    }

    return end.diff(start);
  }

}
